import { useState, useEffect, useCallback } from 'react';
import * as appointmentActions from '../../actions/appointmentActions';
import { ConfirmOrCancelModal } from '../../components/common/standardComponents';
import searchAppointmentService from 'services/searchAppointmentService';
import { useDataApiState } from 'hooks';
import { useAppDispatch, useAppSelector } from '../../store';
import SearchAppointmentsFilters from './comps/searchAppointmentsFilters';
import SearchAppointmentResultsGrid from './comps/searchAppointmentResultsGrid';

function SearchAppointmentsView(props: any) {

    const defaultCriteria = {
        practiceSiteId: 0,
        serviceId: 0,
        appointmentStartTime: '',
        appointmentEndTime: '',
        page: 1,
        pageSize: 10,
        sortOrder: '',
        isSortDescending: true
    };

    const [isDataEdited, setIsDataEdited] = useState<boolean>(false);
    const [isEditAllowed, setIsEditAllowed] = useState<boolean>(false);
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const [confirmFunction, setConfirmFunction] = useState<Function>();
    const [results, setResults] = useDataApiState();
    const [performNewSearch, setPerformNewSearch] = useState(false);
    const [criteria, setCriteria] = useState(defaultCriteria);
    const [showGrid, setShowGrid] = useState<boolean>(false);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);

    const attendanceInfo = useAppSelector((state) => state.appointment.attendanceInfo);

    const dispatch = useAppDispatch();

    const handleSearch = useCallback((newCriteria: any) => {
        setCriteria((prevCriteria) => ({ ...prevCriteria, ...newCriteria }));
        setPerformNewSearch(true);
    }, []);

    const handleShowConfirmationModal = (callThis?: () => void) => {
        setShowConfirmModal(true);
        setConfirmFunction(() => callThis || (() => { }));
    };

    useEffect(() => {
        if (performNewSearch) {
            searchAppointmentService.search(criteria, setResults);
            setPerformNewSearch(false);
        }
    }, [performNewSearch, criteria, setResults]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                await dispatch(appointmentActions.clearSearchAppointmentContext());
                await dispatch(appointmentActions.getAttendanceInfo());
            }
            catch (error: any) {
            }
        };
        fetchInitialData();
    }, []);

    return (
        <>
            <ConfirmOrCancelModal
                className={'confirmMoreInfoModal'}
                title={'Confirm'}
                body={'If you continue you will lose your current progress. Are you sure you want to leave?'}
                isOpen={showConfirmModal}
                confirmLabel={'Confirm'}
                cancelLabel={'Cancel'}
                onConfirm={() => {
                    setShowConfirmModal(false);
                    confirmFunction && confirmFunction();
                }}
                onCancel={() => setShowConfirmModal(false)}
            />
            <SearchAppointmentsFilters
                isDataEdited={isDataEdited}
                setIsEditAllowed={setIsEditAllowed}
                handleShowConfirmationModal={handleShowConfirmationModal}
                onAppointmentSearch={handleSearch}
                results={results}
                setCriteria={setCriteria}
                setShowGrid={setShowGrid}
                showGrid={showGrid}
                setIsEditMode={setIsEditMode}
            />
            <br/>
            <SearchAppointmentResultsGrid
                isDataEdited={isDataEdited}
                setIsDataEdited={setIsDataEdited}
                isEditAllowed={isEditAllowed}
                attendanceInfo={attendanceInfo}
                handleShowConfirmationModal={handleShowConfirmationModal}
                results={results}
                setResults={setResults}
                handleSearch={handleSearch}
                showGrid={showGrid}
                isEditMode={isEditMode}
                setIsEditMode={setIsEditMode}
            />
        </>
    )
}

export default SearchAppointmentsView;